import { createFileRoute } from '@tanstack/react-router';
import Cart from '../../components/cart/cart';
import { seo } from '../../utils/seo';

// The cart is per-visitor state, so it can't be prerendered: only the page shell is static,
// the cart itself is loaded in the browser by the ShopifyStoreProvider (see context/store-context.tsx).
export const Route = createFileRoute('/_layout/cart')({
  head: () => ({ meta: seo({ title: 'Kosár' }) }),
  component: CartRoute
});

function CartRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Kosár</h1>
        <Cart />
      </div>
    </div>
  );
}
